<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <b-form-group :label="t('Start Date')" label-for="start_date">
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="values.startedAt"
              class="form-control"
              name="dateFrom"
              :placeholder="t('Select Date')"
              :config="{
                enableTime: false,
                dateFormat: 'Y-m-d'
              }"
            />
            <b-input-group-append is-text>
              <feather-icon icon="XIcon" class="cursor-pointer" @click="values.startedAt = ''" />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group :label="t('End Date')" label-for="end_date">
          <b-input-group class="input-group-merge">
            <flat-pickr
              v-model="values.expiredAt"
              class="form-control"
              name="dateFrom"
              :placeholder="t('Select Date')"
              :config="{
                enableTime: false,
                dateFormat: 'Y-m-d'
              }"
            />
            <b-input-group-append is-text>
              <feather-icon icon="XIcon" class="cursor-pointer" @click="values.expiredAt = ''" />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group :label="t('API Key')" label-for="key">
          <b-input-group class="input-group-merge">
            <b-form-input
              :id="`key_${values.id}`"
              v-model="values.key"
              name="key"
              :placeholder="t('API Key')"
              :tabindex="4"
              autocomplete="off"
              readonly
            />
          </b-input-group>
        </b-form-group>
        <b-form-checkbox v-model="values.status" name="check-button" switch tabindex="10">
          {{ values.status ? t('Active') : t('Passive') }}
        </b-form-checkbox>
      </b-col>
    </b-row>
    <div class="d-flex flex-column flex-sm-row gap-2 mt-2">
      <b-button
        variant="primary"
        class="mb-1"
        type="submit"
        :disabled="requestIsLoading"
        @click="updateApiKey()"
      >
        {{ requestIsLoading ? t('Loading') : t('Save Changes') }}
      </b-button>
      <b-button
        variant="danger"
        class="mb-1 ml-0 ml-sm-1"
        type="submit"
        :disabled="requestIsLoading"
        @click="deleteApiKey()"
      >
        {{ deleteRequestIsLoading ? t('Loading') : t('Delete Api Key') }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox
} from 'bootstrap-vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';
import flatPickr from 'vue-flatpickr-component';
import useService from '@/auth/service/useService';

export default {
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    flatPickr
  },
  mixins: [helper],

  props: {
    values: {
      type: Object,
      default: () => {
        return {
          startedAt: '',
          expiredAt: '',
          key: '',
          status: false
        };
      }
    }
  },

  data() {
    return {
      requestIsLoading: false,
      deleteRequestIsLoading: false
    };
  },

  methods: {
    updateApiKey() {
      this.requestIsLoading = true;

      const request = {};
      const { id } = this.values;

      request.started_at = this.values.startedAt;
      request.expired_at = this.values.expiredAt;
      request.status = this.values.status;

      useService
        .updateApiKey(id, request)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.requestIsLoading = false;
        });
    },

    deleteApiKey() {
      this.deleteRequestIsLoading = true;

      this.$swal({
        title: `${this.$t('Warning')}!`,
        text: `${this.$t('Api Key Delete Warning')}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${this.$t('Yes')}`,
        cancelButtonText: `${this.$t('No')}`,
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1'
        },
        buttonsStyling: false
      })
        .then(async result => {
          if (result.value) {
            const { id } = this.values;

            useService
              .deleteApiKey(id)
              .then(response => {
                this.showSuccessMessage(`${response.message}`);
                this.$emit('loadItems');
              })
              .catch(messages => {
                if (typeof messages === 'object' && messages && messages.length) {
                  messages.forEach(item => {
                    this.showErrorMessage(item.message);
                  });
                }
              });
          }
        })
        .finally(() => {
          this.deleteRequestIsLoading = false;
        });
    }
  },
  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
